var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mf-button',{attrs:{"label":_vm.btnText,"disabled":_vm.loggedIn},on:{"click":_vm.openWindow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }